import React from "react";
import { numberFormat } from "../../../common/src/utils/FormatFunctions";
import { Grid, Column } from "../../../components/src";

export type ReportRow = {
    name: string;
    type?: string;
    status?: string;
    value: number | string;
    minValue?: string;
    maxValue?: string;
    minValueWarning?: string | number;
    maxValueWarning?: string | number;
    url?: string;
    comment?: string;
    valueField?: string;
};

export type LimitReportInfo = {
    name: string;
    header: string;
    minValueWarningExist: boolean;
    maxValueWarningExist: boolean;
    rows: ReportRow[];
    plot?: any;
};

const linkFormater = (link: string, item: string) => {
    return (
        <div>
            {link ? (
                <a href={link} rel="noopener noreferrer">
                    {item}
                </a>
            ) : null}
        </div>
    );
};

const statusFormatter = (status: string) => {
    if (!status) return <div />;

    // Use explicit Tailwind classes so JIT can detect them
    // min-w-16 ensures consistent badge width
    const baseClasses = "inline-flex items-center justify-center font-medium leading-none whitespace-nowrap text-sm px-2 py-1 rounded text-white min-w-16";

    let colorClasses: string;
    if (status === "Ok") {
        colorClasses = "bg-green-500";
    } else if (status === "Warning") {
        colorClasses = "bg-yellow-500";
    } else {
        colorClasses = "bg-red-500";
    }

    return (
        <div>
            <span className={`${baseClasses} ${colorClasses}`}>{status}</span>
        </div>
    );
};

const formatFunction = (d: any) =>
    typeof d === "number" ? numberFormat(Number(d), Math.abs(d) > 0.995 ? "0%" : "0,0%") : typeof d === "string" ? d : "";

interface LimitReportGridProps {
    limitReportInfo: LimitReportInfo;
}

export const LimitReportGrid = ({ limitReportInfo }: LimitReportGridProps): React.ReactElement => {
    return (
        <div className="border border-gray-300 rounded shadow p-4 bg-gray-100 mt-5">
            <div className="bg-white px-3 py-2">
                {limitReportInfo.rows && (
                    <Grid header={limitReportInfo.header} data={limitReportInfo.rows}>
                        <Column field="name" className="grid-column-sticky" />
                        <Column
                            field="status"
                            format={(status) => {
                                return statusFormatter(status);
                            }}
                        />
                        {limitReportInfo.minValueWarningExist ? (
                            <Column field="minValueWarning" format={formatFunction} className="nowrap center" />
                        ) : null}
                        <Column field="minValue" format={formatFunction} className="nowrap center" />
                        <Column field="value" format={formatFunction} className="nowrap center" />
                        <Column field="maxValue" format={formatFunction} className="nowrap center" />
                        {limitReportInfo.maxValueWarningExist ? (
                            <Column field="maxValueWarning" format={formatFunction} className="nowrap center" />
                        ) : null}
                        <Column
                            className="nowrap"
                            field="comment"
                            format={(comment, item) => {
                                return linkFormater(item.url, comment);
                            }}
                        />
                    </Grid>
                )}
            </div>
        </div>
    );
};
